enum SeatType {
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
  PREMIUMVIP = 'PREMIUMVIP',
  FLASHSEATS = 'FLASHSEATS',
  ACCESSIBLE = 'ACCESSIBLE',
}
export { SeatType };
